var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoYellowPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29338 17.0045C6.17546 19.1363 2.57639 19.8422 0.5 17.7105C3.26852 14.8451 0.5 13.4608 2.57639 11.3844C2.94098 10.9783 3.38456 10.6508 3.88002 10.4219C4.37548 10.193 4.91241 10.0675 5.458 10.0531C6.00359 10.0388 6.54638 10.1358 7.05319 10.3384C7.56001 10.5409 8.0202 10.8446 8.40565 11.231C8.7911 11.6174 9.09372 12.0783 9.295 12.5856C9.49628 13.0929 9.592 13.636 9.57631 14.1815C9.56061 14.7271 9.43384 15.2637 9.20374 15.7586C8.97363 16.2535 8.64503 16.6963 8.23801 17.0599L8.29338 17.0045Z",
    fill: "#F6A72D",
    stroke: "#0C002C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.696 1.80507C17.4275 1.53832 17.1072 1.32945 16.7548 1.19136C16.4024 1.05327 16.0255 0.988889 15.6473 1.0022C15.2693 1.01248 14.8974 1.10007 14.5546 1.25958C14.2118 1.41909 13.9052 1.64713 13.6539 1.92965L6.27344 10.1071C7.07204 10.2652 7.73535 10.7947 8.29686 11.3841C8.80188 11.8871 9.23577 12.3835 9.42955 13.0694L17.5714 5.84711C17.8522 5.59738 18.0793 5.29309 18.2388 4.95277C18.3982 4.61246 18.4867 4.24324 18.4988 3.86762C18.5141 3.48709 18.4506 3.10751 18.3125 2.75262C18.1743 2.39773 17.9645 2.07516 17.696 1.80507Z",
    fill: "#F6A72D",
    stroke: "#0C002C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoYellowPen);
export default __webpack_public_path__ + "static/media/ico_yellow_pen.3f65db3239d77eb929b4f249741c828f.svg";
export { ForwardRef as ReactComponent };